<div class="relative bg-black text-white w-full px-6 md:px-16 py-10 font-sans min-h-[400px] overflow-x-hidden box-border"
    style="border-top: 2px solid #970A0C; background: linear-gradient(180deg, #050505 0%, #111111 45%, #1A1A1A 100%); contain: layout style paint; content-visibility: auto; contain-intrinsic-size: auto 500px;">
    <div class="flex flex-wrap md:flex-nowrap justify-between w-full max-w-full overflow-x-hidden"
        style="contain: layout style paint;">

        <!-- Left Column -->
        <div class="w-full md:w-auto md:flex-1 mb-8 md:mb-0 md:mr-6" style="contain: layout style paint;">
            <div style="transform: translateZ(0); backface-visibility: hidden;">
                <img src="images/logo/logo-text.png" width="320" height="80" alt="Superformance Logo" loading="lazy"
                    class="w-80" [ngClass]="isScreenSmall ? 'my-4 md:px-10 pt-5 align-items-start' : 'mb-4'">
            </div>
            <p
                class="text-sm text-[#D1D1D1] mb-4 w-80 max-w-full whitespace-normal break-words leading-relaxed uppercase">
                The world's most authentic continuation vehicles, engineered with legendary precision and modern
                reliability.
            </p>
            <!-- +194 9900 1950 -->
            <ul class="text-md space-y-2 font-bold uppercase">
                <li class="flex items-center">
                    <a href="tel:+18002976253" (click)="onDealerHotlineClick()"
                        class="flex items-center hover:text-primary transition-colors cursor-pointer">
                        <span class="mr-2"><mat-icon [svgIcon]="'heroicons_outline:phone'" class="text-primary">
                            </mat-icon></span> (800) 297-6253
                    </a>
                </li>
                <li class="flex items-center">
                    <a href="mailto:info@superformance.com" (click)="onFooterEmailClick()"
                        class="flex items-center hover:text-primary transition-colors cursor-pointer">
                        <span class="mr-2"><mat-icon [svgIcon]="'heroicons_outline:envelope'"
                                class="text-primary"></mat-icon></span> {{ 'info@superformance.com' }}
                    </a>
                </li>
                <li class="flex items-center">
                    <a href="https://maps.google.com/?q=14924+Corporate+Rd+S+Ste+39,+Jupiter,+Florida,+33478"
                        target="_blank" rel="noopener noreferrer"
                        class="flex items-center hover:text-primary transition-colors cursor-pointer">
                        <span class="mr-2"><mat-icon [svgIcon]="'heroicons_outline:map-pin'"
                                class="text-primary"></mat-icon></span> 14924 Corporate Rd S Ste 39, Jupiter, Florida,
                        33478
                    </a>
                </li>
            </ul>
        </div>

        <!-- Middle Columns -->
        <div class="flex w-full md:flex-1 justify-start md:justify-between flex-wrap md:ml-6 gap-4 lg:gap-6 xl:gap-8"
            style="contain: layout style paint;">
            <!-- Vehicles Column -->
            <div class="w-full sm:w-[calc(50%-0.5rem)] md:flex-1 md:min-w-[150px] lg:min-w-[180px] mb-6"
                style="contain: layout style paint;">
                <h3 class="font-semibold text-lg mb-3 uppercase">Vehicles</h3>
                @if (isLoadingVehicles) {
                <div class="flex justify-center items-center py-4">
                    <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
                </div>
                } @else {
                <ul class="space-y-2 text-sm text-gray-300 uppercase">
                    @for (vehicle of vehicles; track vehicle.id) {
                    <li>
                        <a [href]="vehicle.hasSubVehicles ? '/vehicles/' + slugify(vehicle.name) : '/vehicles/' + slugify(vehicle.name) + '/detail'"
                            (click)="$event.preventDefault(); navigateToVehicle(vehicle)"
                            class="hover:text-primary transition-colors cursor-pointer">
                            {{ vehicle.name }}
                        </a>
                    </li>
                    }
                </ul>
                }
            </div>

            <!-- Company Column -->
            <div class="w-full sm:w-[calc(50%-0.5rem)] md:flex-1 md:min-w-[150px] lg:min-w-[180px] mb-6"
                style="contain: layout style paint;">
                <h3 class="font-semibold text-lg mb-3 uppercase">Company</h3>
                <ul class="space-y-2 text-sm text-[#D1D1D1] uppercase">
                    <li><a routerLink="/about" class="hover:text-primary transition-colors cursor-pointer">About Us</a></li>
                    <li><a routerLink="/license" class="hover:text-primary transition-colors cursor-pointer">License</a></li>
                    <li><a routerLink="/inventory" class="hover:text-primary transition-colors cursor-pointer">Our Inventory</a></li>
                    <li><a routerLink="/gallery" class="hover:text-primary transition-colors cursor-pointer">Gallery</a></li>
                    <li><a routerLink="/privacy-policy" class="hover:text-primary transition-colors cursor-pointer">Privacy Policy</a></li>
                </ul>
            </div>

            <!-- Support Column -->
            <div class="w-full sm:w-[calc(50%-0.5rem)] md:flex-1 md:min-w-[150px] lg:min-w-[180px] mb-6"
                style="contain: layout style paint;">
                <h3 class="font-semibold text-lg mb-3 uppercase">Support</h3>
                <ul class="space-y-2 text-sm text-[#D1D1D1] uppercase">
                    <li><a routerLink="/dealers" class="hover:text-primary transition-colors cursor-pointer">Find a Dealer</a></li>
                    <li><a routerLink="/faq" class="hover:text-primary transition-colors cursor-pointer">FAQs</a></li>
                    <li><a routerLink="/contact" class="hover:text-primary transition-colors cursor-pointer">Contact Us</a></li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Bottom Footer -->
    <div class="mt-2" style="contain: layout style paint;">
        <!-- Follow Us and Licensed By Row -->
        <div
            class="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-6 pb-6 border-b border-gray-800">
            <!-- Follow Us - Left -->
            <div class="flex flex-col items-center md:items-start">
                <h3 class="font-semibold text-lg mb-3 uppercase">Follow Us</h3>
                <div class="flex space-x-4">
                    <a href="https://www.facebook.com/Superformance/" target="_blank" rel="noopener noreferrer"
                        class="text-white hover:text-primary transition-colors duration-300"
                        aria-label="Follow us on Facebook">
                        <svg class="w-8 h-8 fill-current" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path
                                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                        </svg>
                    </a>
                    <a href="https://x.com/superformance1" target="_blank" rel="noopener noreferrer"
                        class="text-white hover:text-primary transition-colors duration-300"
                        aria-label="Follow us on X (Twitter)">
                        <svg class="w-8 h-8 fill-current" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path
                                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                        </svg>
                    </a>
                    <a href="https://www.youtube.com/channel/UC2iylXycyk3fP2brI2Wr0Yg" target="_blank"
                        rel="noopener noreferrer" class="text-white hover:text-primary transition-colors duration-300"
                        aria-label="Follow us on YouTube">
                        <svg class="w-8 h-8 fill-current" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path
                                d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                        </svg>
                    </a>
                </div>
            </div>

            <!-- License Images - Right -->
            @if (licenseSection && licenseSection.images && licenseSection.images.length > 0) {
            <div class="flex flex-col items-center md:items-end">
                <h3 class="font-semibold text-lg mb-3 uppercase">Officially licensed by:</h3>
                <div class="flex flex-wrap gap-4 justify-center md:justify-end">
                    @for (image of licenseSection.images; track image.id) {
                    <div style="transform: translateZ(0); backface-visibility: hidden;">
                        @if(image.fullUrl) {
                        <img [src]="image.fullUrl" width="120" height="40"
                            [alt]="image.alternativeText || 'License logo'" loading="lazy"
                            class="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity">
                        }
                    </div>
                    }
                </div>
            </div>
            }
        </div>

        <!-- Legal Text -->
        <p class="mb-4 text-xs text-[#D1D1D1] leading-relaxed uppercase">
            The Superformance MKIII is built under license from Carroll Shelby Licensing Inc. The GT40® is built under
            license from
            Safir Spares LLC, the holders of the GT40® trademark. The Corvette® Grand Sport is built under license from
            General
            Motors Company. Shelby®, Carroll Shelby®, Carroll Shelby's Signature & Initials®, Carroll Shelby's
            Photograph®, 427R,
            427 S/CR 289®, Shelby Cobra 289 FIA and the Shelby Cobra "Daytona" Coupe®, Cobra® shape and design (trade
            dress) of the
            Shelby Cobra Daytona Coupe are registered trademarks and/or the trade dress of Carroll Shelby Licensing,
            Inc.
            (Shelby). Colors seen on promotional images may have been enhanced.
        </p>
        <!-- Copyright Row -->
        <div class="flex flex-col md:flex-row md:items-center md:justify-center gap-4 mb-3">
            <!-- Copyright -->
            <p class="text-center text-[#D1D1D1] text-sm font-bold uppercase">Superformance {{ currentYear }} | All
                Rights
                Reserved</p>
        </div>

        <!-- Country Flag -->
        @if (countryFlagImage) {
        <div class="flex justify-center" style="transform: translateZ(0); backface-visibility: hidden;">
            @if(countryFlagImage.fullUrl) {
            <img [src]="countryFlagImage.fullUrl" width="56" height="30"
                [alt]="countryFlagImage.alternativeText || 'Country Flag'" loading="lazy"
                class="h-auto w-12 md:w-14 object-contain">
            }
        </div>
        }
    </div>
</div>
